import { createBEM } from "@/libs";
import { useSetState } from "ahooks";
import { Popup } from "antd-mobile";
import { PropsWithChildren } from "react";
import { createRoot } from "react-dom/client";
import "./index.scss";
import { PasswordKitInput, PasswordKitInputProps } from "./input";
export type PasswordKitProps = PropsWithChildren<{
  onClose?: PasswordKitInputProps["onFill"];
}>;
const b = createBEM("i-passwordkit");
export const PasswordKitBEM = b;
export const PasswordKit = ({
  onClose
}: PasswordKitProps) => {
  const [state, setState] = useSetState({
    show: true,
    text: ""
  });
  return <Popup visible={state.show} afterClose={() => {
    onClose?.(state.text);
  }} onMaskClick={() => {
    setState({
      show: false
    });
  }} data-sentry-element="Popup" data-sentry-component="PasswordKit" data-sentry-source-file="index.tsx">
      <PasswordKitInput withKeyboard onFill={text => {
      setState({
        show: false,
        text
      });
    }} data-sentry-element="PasswordKitInput" data-sentry-source-file="index.tsx" />
    </Popup>;
};
export const passwordkit = (): Promise<string> => {
  return new Promise(resolve => {
    const div = document.createElement("div");
    const id = Math.random().toString(36).slice(2);
    div.id = id;
    const cp = <PasswordKit onClose={text => {
      root.unmount();
      div.remove();
      resolve(text);
    }} />;
    const root = createRoot(div);
    document.body.appendChild(div);
    root.render(cp);
  });
};